const LandingApiResources = {
  hotelInfo: 'landing/hotel_info',
  cancellationPolicy: 'landing/cancellation_policy',
  createBooking: 'landing/booking_request',
  authorizeCharge: 'landing/authorize_charge',
  rejectBookingRequest: 'landing/reject_booking_request',
  roomTypeInfo: 'landing/room_types',
  gmoLegalInfo: 'landing/gmo_legal_information',
};
export default LandingApiResources;
